export class MissingFirebaseConfig extends Error {
  constructor() {
    super("Firebase configs are missing. Check .env file");
    this.name = "Firebase config missing";
  }
}
